export default {"src":"/_next/static/media/travelOutline75_40.cefc0ba4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};